// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3xMKo","clinicsSelect":"TableHeading_clinicsSelect__hyxCO"};